<template>
  <legacy-wechat-shop-board-detail v-if="isWechat" embedded />
  <legacy-shop-board-detail v-else embedded />
</template>

<script>
import LegacyShopBoardDetail from '../uc_shop_board/detail.vue'
import LegacyWechatShopBoardDetail from '../uc_shop_board/detail_wechat.vue'

export default {
  name: 'NewShopBoardDetailPage',
  components: { LegacyShopBoardDetail, LegacyWechatShopBoardDetail },
  computed: {
    isWechat() {
      return String(this.$route.query.platform) === '7'
    }
  }
}
</script>
